import { format } from "date-fns";
import { ptBR } from "date-fns/locale";
import { useTranslation } from "react-i18next";
import { Badge } from "@/components/ui/badge";
import { EventTooltip } from "./EventTooltip";
import type { CustomEventProps } from "./CalendarEventTypes";
import { getEventPetsLabel } from "./calendarEventUtils";
import { AppointmentDriverBadge } from "@/components/calendar/AppointmentDriverBadge";

export function MonthEvent({ event, statuses }: CustomEventProps) {
  const { t } = useTranslation("calendar");
  const timeLabel = format(event.start, "HH:mm", { locale: ptBR });

  return (
    <EventTooltip event={event} statuses={statuses}>
      <div className="min-w-0 flex items-center gap-1 flex-wrap justify-between">
        <p className="truncate text-[10px] leading-3 font-medium">
          {getEventPetsLabel(event)} · {timeLabel}
        </p>
        <div className="flex items-center gap-1">
          {event.financial_status === "pago" ? (
            <Badge className="h-4 px-1 text-[9px] font-medium bg-emerald-700 text-white border-transparent">
              {t("financialSettled")}
            </Badge>
          ) : null}
          <AppointmentDriverBadge
            isTaxiDog={event.is_taxi_dog}
            driverType={event.taxi_dog_type}
            iconClassName="h-2 w-2"
            showText={false}
          />
        </div>
      </div>
    </EventTooltip>
  );
}
